import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import { RecordIcon } from './RecordIcon';
import type { IFavouriteToggleProps } from './IFavouriteToggleProps';
import { useFavourite } from './useFavourite';

/**
 * «Обране» (прототип v4, UIUX controls/icon-button): кнопка 32px із зіркою й підписом, aria-pressed; увімкнена — тло #fdf3dc, текст
 * #b7791f, рамка #e0b04a і заповнена зірка; підказка «Додати до обраного» / «Вилучити з обраного».
 */
export function FavouriteToggle({ recordId, disabledHint }: IFavouriteToggleProps) {
  const { t } = useTranslation();
  const fav = useFavourite(recordId);
  const label = fav.on ? t('recordPage.favRemove') : t('recordPage.favAdd');
  return (
    <button type="button" className={cx('rec-btn', 'rec-btn--fav', fav.on && 'is-on')} aria-pressed={fav.on} title={disabledHint ?? label} aria-label={label}
      disabled={Boolean(disabledHint)} onClick={fav.toggle}>
      <RecordIcon name="star" size={15} filled={fav.on} />{t('recordPage.favourite')}
    </button>
  );
}
